import { uid } from "./postprocess";

const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
export const tokens = (text) => text.split(/\s+/).filter(Boolean);

export const LINE_PRESETS = {
  off: { label: "Off — keep natural sentences" },
  punchy: { label: "Punchy — up to 3 words", maxWords: 3, maxChars: 20 },
  medium: { label: "Medium — up to 5 words", maxWords: 5, maxChars: 30 },
  long: { label: "Relaxed — up to 8 words", maxWords: 8, maxChars: 44 },
};
export const SENTENCE = { maxWords: 14, maxChars: 72, gap: 1.0 };

export const hasWordTiming = (c) => Array.isArray(c.words) && c.words.length > 0 && c.words.length === tokens(c.text).length;

// Word timings: real (from Whisper) when they still match the text, otherwise estimated by word length.
export function capWords(c) {
  const toks = tokens(c.text);
  if (hasWordTiming(c)) {
    return toks.map((w, i) => ({ w, s: clamp(c.words[i].s, c.start, c.end), e: clamp(c.words[i].e, c.start, c.end), real: true }));
  }
  const total = toks.reduce((a, w) => a + w.length + 1, 0) || 1;
  const dur = c.end - c.start;
  let acc = c.start;
  return toks.map((w) => {
    const s = acc;
    acc += (dur * (w.length + 1)) / total;
    return { w, s, e: acc };
  });
}

export function groupWords(words, { maxWords, maxChars, gap = 0.7 }) {
  const out = [];
  let cur = [];
  const flush = () => {
    if (!cur.length) return;
    out.push({ start: cur[0].s, end: cur[cur.length - 1].e, text: cur.map((w) => w.w).join(" "), words: cur.map(({ w, s, e }) => ({ w, s, e })) });
    cur = [];
  };
  for (const w of words) {
    const last = cur[cur.length - 1];
    const len = cur.reduce((a, x) => a + x.w.length + 1, 0) + w.w.length;
    if (cur.length && (cur.length >= maxWords || len > maxChars || w.s - last.e > gap)) flush();
    cur.push(w);
    if (/[.!?।]$/.test(w.w)) flush();
  }
  flush();
  return out;
}

export function reflowCaptions(caps, presetKey) {
  const p = LINE_PRESETS[presetKey];
  if (!p || !p.maxWords) return caps;
  const out = caps.flatMap((c) => {
    const ws = capWords(c);
    if (ws.length <= p.maxWords && c.text.length <= p.maxChars) return [{ ...c }];
    const real = hasWordTiming(c);
    return groupWords(ws, { ...p, gap: real ? 0.7 : 99 }).map((g) => ({
      id: uid(), start: +g.start.toFixed(3), end: +g.end.toFixed(3), text: g.text, words: real ? g.words : undefined, flag: c.flag,
    }));
  });
  out.forEach((c, i) => {
    if (c.end - c.start < 0.5) c.end = +Math.min(c.start + 0.5, out[i + 1] ? out[i + 1].start : c.start + 0.5).toFixed(3);
  });
  return out;
}
